import React from 'react';
import $ from "jquery";

var GraphTableView = React.createClass({
  getInitialState: function() {
    var state = {
      
    };
    return state;
  },

  handleLineClick: function(e, i){
    if (this.props.objectPageKey && this.props.data.ids[i]) {
      if (e.button === 0) {
        $(document).trigger("changePage", [this.props.objectPageKey, {id: this.props.data.ids[i]}]);
      } else if (e.button === 1) {
        $(document).trigger("openPage", [this.props.objectPageKey, {id: this.props.data.ids[i]}]);
      }
    }
  },


  render: function() {
    let columns = null;
    let rows = [];
    if (this.props.data.datasets[0]) {
      columns = this.props.data.datasets[0].columns.map(function(columnName, i){
        return (
          <th key={i}>
            {columnName}
          </th>
        );
      });
      this.props.data.labels.map(function(label, i){
        if (this.props.objectPageKey && this.props.data.ids[i]) {
          label =  
            <a onMouseDown={function(e){this.handleLineClick(e,i)}.bind(this)}>
              {label}
            </a>
        }
        let values = this.props.data.datasets[0].data[i];
        values.map(function(subrow, j){  // eslint-disable-line
          let cells = [];
          cells.push(
            <td key={0}>{j === 0 ? label : null}</td>
          )
          subrow.map(function(cell, k){  // eslint-disable-line
            cells.push(
              <td key={cells.length}>{cell}</td>
            );
          })
          rows.push(
            <tr key={rows.length}>{cells}</tr>
          );
        });
      }.bind(this));
    }
    return (
      <table className="table table-hover">
        <thead>
          <tr>{columns}</tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    );
  },
});

export default GraphTableView;



// WEBPACK FOOTER //
// ./src/GraphTableView.js